import { Injectable } from '@angular/core';
import firebase from 'firebase';
import {AngularFireAuth} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private firebaseAuth: AngularFireAuth) { }

  signIn(email: string, password: string) {
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    return this.firebaseAuth.signInWithEmailAndPassword(email, password);
  }

  logout() {
    firebase.auth().signOut();
  }

  isAuthenticated(): boolean {
    const user = firebase.auth().currentUser;
    return !!user;
  }
}
